/* ============================================================
   DATZZY — PDP interactions (Stage 2.5 → 2.7)
   Wiring only: variant-filtered gallery, native variant selection, qty,
   sticky bar, native Shopify AJAX add-to-cart. Never fabricates cart state.
   Idempotent + safe for Theme Editor section reloads.
   ============================================================ */
(function(){
  function initPdp(root){
    var scope = (root && root.querySelector) ? root : document;
    var pdp = scope.querySelector('[data-pdp]') || document.querySelector('[data-pdp]');
    if(!pdp || pdp.dataset.pdpBound) return;
    pdp.dataset.pdpBound = '1';
    // The variant JSON and the sticky bar are siblings of [data-pdp] inside the same
    // .shopify-section wrapper — query them from the section container, not from [data-pdp].
    var container = pdp.closest('.shopify-section') || document;

    var main      = pdp.querySelector('[data-main]');
    var thumbs    = pdp.querySelector('[data-thumbs]');
    var idInput   = pdp.querySelector('[data-variant-id]');
    var priceEl   = pdp.querySelector('[data-price]');
    var strikeEl  = pdp.querySelector('[data-strike]');
    var saveEl    = pdp.querySelector('[data-save]');
    var colorName = pdp.querySelector('[data-color-name]');
    var addBtn    = pdp.querySelector('[data-addcart]');
    var ctaLabel  = pdp.querySelector('[data-cta-label]');
    var qtyEl     = pdp.querySelector('[data-qty]');
    var qtyInput  = pdp.querySelector('[data-qty-input]');
    var form      = pdp.querySelector('#pdp-form');

    /* ---- subscription (native Shopify selling plans / Appstle) ---- */
    var purchaseEl     = pdp.querySelector('[data-purchase]');
    var planInput      = pdp.querySelector('[data-selling-plan-input]');
    var subOpt         = purchaseEl ? purchaseEl.querySelector('[data-plan="subscribe"]') : null;
    var onetimePriceEl = purchaseEl ? purchaseEl.querySelector('[data-onetime-price]') : null;
    var subPriceEl     = purchaseEl ? purchaseEl.querySelector('[data-sub-price]') : null;
    var subStrikeEl    = purchaseEl ? purchaseEl.querySelector('[data-sub-strike]') : null;
    // Only true when the server rendered plan options (product has selling plans).
    var hasSub = !!(purchaseEl && purchaseEl.querySelector('[data-plan]'));
    var plan = 'one-time';

    function ctaText(v){
      if(!v || !v.available) return 'Niedostępny';
      return (hasSub && plan === 'subscribe') ? 'Subskrybuj i oszczędzaj' : 'Dodaj do koszyka';
    }
    // Push the current plan → the form's selling_plan input (empty for one-time),
    // and refresh the CTA/sticky. Called on plan change and on variant change.
    function applyPlan(){
      var v = current();
      // Defensive: with no resolved variant, never force the CTA to "Niedostępny"
      // just because a plan was clicked — leave the server-rendered state intact.
      if(!v || !v.id) return;
      // Subscription only applies when THIS variant actually has a selling plan.
      var subActive = hasSub && plan === 'subscribe' && v.sellingPlanId;
      if(planInput) planInput.value = subActive ? v.sellingPlanId : '';
      if(ctaLabel)  ctaLabel.textContent = ctaText(v);
      updateSticky();
    }

    var variants = [];
    try { variants = JSON.parse((container.querySelector('[data-pdp-variants]') || {}).textContent || '[]'); } catch(e){}
    // Which dimensions this product actually has (colour and/or Pakiet), from real data.
    var hasColor = variants.some(function(v){ return v.color != null; });
    var hasPak   = variants.some(function(v){ return v.pkg != null; });
    var selColor = null, selPkg = null;
    function current(){ return variants.filter(function(v){ return String(v.id) === String(idInput && idInput.value); })[0] || variants[0] || {}; }
    function pick(list){ var a = list.filter(function(v){ return v.available; }); return a[0] || list[0]; }
    // Resolve the variant for a colour + package combination. Prefer the exact combo; if it
    // is missing/unavailable keep the colour and relax the package, then keep the package.
    function resolve(color, pkg){
      var exact = variants.filter(function(v){ return (!hasColor || v.color === color) && (!hasPak || v.pkg === pkg); });
      if(exact.length) return pick(exact);
      if(hasColor){ var sc = variants.filter(function(v){ return v.color === color; }); if(sc.length) return pick(sc); }
      if(hasPak){ var sp = variants.filter(function(v){ return v.pkg === pkg; }); if(sp.length) return pick(sp); }
      return variants[0] || {};
    }
    function syncButtons(v){
      pdp.querySelectorAll('.color-sw').forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-color') === v.color); });
      pdp.querySelectorAll('.pak-seg').forEach(function(b){
        var on = b.getAttribute('data-pkg') === v.pkg;
        b.classList.toggle('active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    // Central selection: resolve → update the whole buy box → sync buttons + URL.
    function apply(){
      var v = resolve(selColor, selPkg);
      if(!v || !v.id) return;
      selColor = v.color; selPkg = v.pkg;
      selectVariant(v);
      // pack badges show the real price of each pack in the selected colour
      pdp.querySelectorAll('[data-pak-badge]').forEach(function(b){
        var bv = variants.filter(function(x){ return x.pkg === b.getAttribute('data-pak-badge') && (!hasColor || x.color === v.color); })[0];
        var el = b.querySelector('[data-pak-price]');
        if(bv && el) el.textContent = bv.price;
      });
      syncButtons(v);
      if(window.history && history.replaceState){ try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch(e){} }
    }

    /* ---- gallery (variant-filtered) ---- */
    function showColorThumbs(color){
      if(!thumbs) return null;
      var firstVisible = null;
      thumbs.querySelectorAll('.pdp-thumb').forEach(function(t){
        var tc = t.getAttribute('data-color') || '';
        var show = (variants.length < 2) || tc === '' || tc === color;
        t.hidden = !show;
        if(show && !firstVisible) firstVisible = t;
      });
      return firstVisible;
    }
    function setMainFromThumb(t){
      if(!t || !main) return;
      thumbs.querySelectorAll('.pdp-thumb').forEach(function(x){ x.classList.remove('active'); });
      t.classList.add('active');
      // full-bleed photos fill the stage; renders/pack shots keep their white inset
      if(main.parentElement) main.parentElement.classList.toggle('is-bleed', t.classList.contains('is-bleed'));
      var vid = pdp.querySelector('[data-main-video]');
      var vsrc = t.getAttribute('data-video');
      if(vid && vsrc){
        // video thumb: show the <video>, keep the <img> in place (hidden) so the stage keeps its box
        if(vid.getAttribute('src') !== vsrc) vid.src = vsrc;
        vid.hidden = false; main.style.visibility = 'hidden';
        var pr = vid.play(); if(pr && pr.catch) pr.catch(function(){});
        return;
      }
      if(vid && !vid.hidden){ try { vid.pause(); } catch(e){} vid.hidden = true; main.style.visibility = ''; }
      var im = t.querySelector('img');
      main.src = t.getAttribute('data-full') || (im ? im.src : main.src);
    }
    if(thumbs){
      thumbs.querySelectorAll('.pdp-thumb').forEach(function(t){
        t.addEventListener('click', function(){ setMainFromThumb(t); });
      });
    }

    /* ---- quantity ---- */
    var qty = 1;
    function setQty(n){ qty = Math.max(1, n); if(qtyEl) qtyEl.textContent = qty; if(qtyInput) qtyInput.value = qty; updateSticky(); }
    var qi = pdp.querySelector('[data-qi]'); if(qi) qi.addEventListener('click', function(){ setQty(qty + 1); });
    var qd = pdp.querySelector('[data-qd]'); if(qd) qd.addEventListener('click', function(){ setQty(qty - 1); });

    /* ---- native variant selection ---- */
    function selectVariant(v){
      if(!v || !v.id) return;
      if(idInput)   idInput.value = v.id;
      if(priceEl)   priceEl.textContent = v.price;
      if(strikeEl){ if(v.compareAt){ strikeEl.textContent = v.compareAt; strikeEl.style.display = ''; } else { strikeEl.textContent = ''; strikeEl.style.display = 'none'; } }
      if(saveEl){ if(v.compareAt){ saveEl.textContent = '-' + v.savePct + '%'; saveEl.hidden = false; } else { saveEl.hidden = true; } }
      if(colorName) colorName.textContent = v.color;
      if(addBtn){ addBtn.disabled = !v.available; addBtn.setAttribute('aria-disabled', v.available ? 'false' : 'true'); }
      if(ctaLabel) ctaLabel.textContent = v.available ? 'Dodaj do koszyka' : 'Niedostępny';
      var firstVisible = showColorThumbs(v.color);
      var own = (thumbs && v.mediaId) ? thumbs.querySelector('.pdp-thumb[data-media-id="' + v.mediaId + '"]') : null;
      setMainFromThumb(own && !own.hidden ? own : firstVisible);
      // keep subscription prices + selling_plan id in sync with the selected variant
      if(hasSub){
        if(onetimePriceEl) onetimePriceEl.textContent = v.price;
        if(subPriceEl && v.subPrice) subPriceEl.textContent = v.subPrice;
        if(subStrikeEl) subStrikeEl.textContent = v.price;
        if(subOpt && v.sellingPlanId) subOpt.setAttribute('data-selling-plan', v.sellingPlanId);
        applyPlan();
      }
      updateSticky();
    }
    /* ---- purchase plan (one-time vs subscribe) ---- */
    if(hasSub && purchaseEl){
      purchaseEl.querySelectorAll('.popt').forEach(function(o){
        o.addEventListener('click', function(){
          purchaseEl.querySelectorAll('.popt').forEach(function(x){ x.classList.remove('active'); });
          o.classList.add('active');
          plan = o.getAttribute('data-plan') || 'one-time';
          applyPlan();
        });
      });
    }
    // Colour change → keep the current package. Package change → keep the current colour.
    pdp.querySelectorAll('.color-sw').forEach(function(sw){
      sw.addEventListener('click', function(){ selColor = sw.getAttribute('data-color'); apply(); });
    });
    pdp.querySelectorAll('.pak-seg').forEach(function(seg){
      seg.addEventListener('click', function(){ selPkg = seg.getAttribute('data-pkg'); apply(); });
    });

    /* ---- sticky buy bar ---- */
    var sticky        = container.querySelector('[data-sticky]');
    var stickyImg     = container.querySelector('[data-sticky-img]');
    var stickyVariant = container.querySelector('[data-sticky-variant]');
    var stickyPrice   = container.querySelector('[data-sticky-price]');
    var stickyAdd     = container.querySelector('[data-sticky-add]');
    function updateSticky(){
      var v = current(); if(!v.id) return;
      if(stickyImg && v.img)  stickyImg.src = v.img;
      if(stickyVariant)       stickyVariant.textContent = [ (variants.length > 1 ? v.color : ''), v.pkg ].filter(Boolean).join(' · ');
      if(stickyPrice)         stickyPrice.textContent = v.price;
    }
    var buybox = pdp.querySelector('[data-buybox]');
    if(sticky && buybox && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        var e = entries[0];
        if(e.isIntersecting) sticky.classList.remove('show');
        else if(e.boundingClientRect.top < 0) sticky.classList.add('show');
        else sticky.classList.remove('show');
      }, { threshold: 0 }).observe(buybox);
    }

    /* ---- native Shopify add-to-cart (shared window.dzCart helper) ---- */
    function flash(){
      if(!ctaLabel) return; var t = ctaLabel.textContent;
      ctaLabel.textContent = 'Dodano ✓'; setTimeout(function(){ ctaLabel.textContent = t; }, 1600);
    }
    function addToCart(){
      var v = current(); if(!v.id || !v.available || !window.dzCart) return;
      // Subscribe → include the variant's selling_plan id; one-time → omit it.
      var spid = (hasSub && plan === 'subscribe' && v.sellingPlanId) ? v.sellingPlanId : undefined;
      window.dzCart.add(v.id, qty, null, spid).then(function(cart){ if(cart) flash(); });
    }
    if(form)      form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(); });
    if(stickyAdd) stickyAdd.addEventListener('click', function(){ addToCart(); });

    /* ---- initial state = current variant (colour + package) ---- */
    setQty(1);
    var init = current();
    selColor = hasColor ? init.color : null;
    selPkg   = hasPak ? init.pkg : null;
    apply();
    /* Cart count/state/drawer are initialized once, globally, by dz-cart.js. */
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initPdp(); });
  else initPdp();
  if(window.Shopify && window.Shopify.designMode){
    document.addEventListener('shopify:section:load', function(e){ initPdp(e.target); });
  }
})();
